export const slideDesigns = [
    {
        'slideType': 'Benefits',
        'steps': [
            {
                'widgetIds': [{id: 'EJMLOY7EA0'}, {id: 'k2lolRXNgx'} ]
            },
            {
                'widgetIds': [{id: '1818KY3c67'}, {id: 'x1GyTcamIW'} ]
            },
            {
                'widgetIds': [{id: 'OvwS9Oiq-P'}, {id: 'a3prDtuvz5'} ]
            }
        ]
    },
    {
        'slideType': 'Questionnaire',
        'steps': [
            {
                'widgetIds': [{id: '4A4h7S0WwA'}, {id: 'nfB2WvoUYU'}, {id: 'M48Fo2JIpM'} ]
            },
            {
                'widgetIds': [{id: 'B7YQczq5OH'}, {id: 'nS4JyMQCKl'}, {id: 'c7G4XffN_a'} ]
            }
        ]
    },
    {
        'slideType': 'Total Cost of Ownership',
        'steps': [
            {
                'widgetIds': [{id: 'jrpzVaysAz'} ]
            },
            {
                'widgetIds': [{id: 'BXLaHI9OH8'}, {id: 'KbLs-68TUI'}, {id: 'gTcxUjCB-x'} ]
            },
            {
                'widgetIds': [{id: 'gnuCWNaLYU'} ]
            },
            {
                'widgetIds': [{id: 'SFVSpzSsMc'}, {id: '4JtxkfJess'}, {id: 's-5Mkj4VHG'} ]
            }
        ]
    },
    {
        'slideType': 'Value Driver Detail',
        'steps': [
            {
                'widgetIds': [{id: '2DoJk95p84'} ]
            },
            {
                'widgetIds': [{id: 'Rd_YcVs9VB'}, {id: '-wM-EE7X_C'}, {id: 'Brw35UubIt'} ]
            }
        ]
    },
    {
        'slideType': 'Waterfall',
        'steps': [
            {
                'widgetIds': [{id: 'ERBuZ6VJhE'} ]
            },
            {
                'widgetIds': [{id: 'fazaCeESaj'} ]
            },
            {
                'widgetIds': [{id: 'IvzwmolOm9'}, {id: 'BbeuewttEw'}, {id: 'deuLeq2bU7'} ]
            },
            {
                'widgetIds': [{id: 'am3rHgL34q'}, {id: 'nczdjHXDVy'} ]
            }
        ]
    }
]
